import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { GetRenewalActionsEffects } from './effects';
import { featureKey, reducer } from './reducer';
import { GetRenewalActionsService } from './service';

@NgModule({
  imports: [EffectsModule.forFeature([GetRenewalActionsEffects]), StoreModule.forFeature(featureKey, reducer)],
  providers: [GetRenewalActionsService],
})
export class GetRenewalActionsModule {}
